import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import HomePage from "./pages/home";
import HashtagFinderPage from "./pages/rednote-hashtag-finder"
import XiaohongshuForTiktokUsersAQuickGuidePage from "./pages/xiaohongshu-for-tiktok-users-a-quick-guide"
import HowToChangeUsernameOnRedNotePage from "./pages/how-to-change-username-on-rednote"
import JinShengYuanTiktokViralSongChineseLyricsPage from "./pages/jin-sheng-yuan-tiktok-viral-song-chinese-lyrics"
import RednoteHashtagsForEnglishSpeakersPage from "./pages/rednote-hashtags-for-english-speakers"
import Top100RednoteMandarinChineseSlangsPage from "./pages/top-100-rednote-mandarin-chinese-slangs"
import Blogs from "./pages/blogs"

import './styles/globals.css'



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/rednote-hashtag-finder" element={<HashtagFinderPage />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/xiaohongshu-for-tiktok-users-a-quick-guide" element={<XiaohongshuForTiktokUsersAQuickGuidePage />} />
        <Route path="/how-to-change-username-on-rednote" element={<HowToChangeUsernameOnRedNotePage />} />
        <Route path="/jin-sheng-yuan-tiktok-viral-song-chinese-lyrics" element={<JinShengYuanTiktokViralSongChineseLyricsPage />}/>
        <Route path="/rednote-hashtags-for-english-speakers" element={<RednoteHashtagsForEnglishSpeakersPage />} />
        <Route path="/top-100-rednote-mandarin-chinese-slangs" element={<Top100RednoteMandarinChineseSlangsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
